import { Component, HostListener, Input, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { MapControlService } from '../../services/map-control.service';
import { EventLogicService } from '../../services/event-logic.service';
import { Subscription, skip } from 'rxjs';
import { Events } from '../../constants/events';
import { EnvironmentService } from '../../services/img-source.service';
import { CommonCabService } from 'src/app/trip-view-cab/services/common-cab.service';
import { DateUtils } from 'src/app/utils/days-utils';
// import { driverData } from './mockDriverData';
@Component({
  selector: 'app-trip-player',
  templateUrl: './trip-player.component.html',
  styleUrls: ['./trip-player.component.scss'],
})
export class TripPlayerComponent implements OnInit {
  isShuttle: boolean;
  @Input() driverData;
  imgSrc: string;
  replayImgSrc: string;
  zoom: number = 100;
  zoomProgress;
  totalTripTime: number;
  rangerValue: number;
  progress: number = 0;

  tripDetails: any;
  tripDetailsCab: any;
  locationList: any[] = [];

  tripCurrTime: String = '--:--';
  isPaused: boolean = true;

  stopsTime: number[] = [];
  stopsIndex: number[] = [];

  playbackSpeed: number = 1;
  showDropdown: boolean = false;
  shuttleStops: any;

  timestamps: string[] = [];

  tripEnded: boolean = false;
  vehicleStoppageIndexes: number[];

  isStopVisible: boolean[];
  showOffice: boolean = false;

  activePlaybackSpeed: string = '1';

  sosAlertRelativeTimeStamps: any[];
  seatBeltAlertTime:any[];
  shuttleStopRelativeTimeStamps: any[] = [];
  vehicleStoppageRelativeTimeStamps: any[];
  deviceOffRelativeTimeStamps: any[];
  noNetworkRelativeTimeStamps: any[];
  callEmployee:any= [];

  iconsList: any[] = [];

  tripPlayerSubscription: Subscription;
  tripEndCallSubscription: Subscription;
  callForPauseSubscription: Subscription;
  callForFilterChangeSubscription: Subscription;
  locationListResSubsription: Subscription;

  isActualPause: boolean;
  timeZone:string = 'Asia/Kolkata'
  events: typeof Events = Events;
  eventVisibility: Map<string, boolean> =
    this.mapControlService.eventVisibility;
  employeeDetails: any;
  noShow: any;
  signInLocationGeoCordsMap: any;
  cabSignInLocations:any;
  cabSignOutLocations:any;
  vehicleArrivedIntervals: any;

  constructor(
    private commonService: CommonService,
    private commonCabService: CommonCabService,
    private mapControlService: MapControlService,
    private eventLogicService: EventLogicService,
    private envService: EnvironmentService
  ) { }

  // HostListener decorator to listen for the keyup event
  // Keyboard Control -> Space: Pause/Play, Left/Right Arrow: Backward/Forward
  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    switch (event.key) {
      case ' ': {
        let action = 'pause';
        if (this.isPaused) {
          action = 'play';
        }
        this.handleControl(action);
        break;
      }
      case 'ArrowLeft': {
        this.handleControl('backward');
        break;
      }
      case 'ArrowRight': {
        this.handleControl('forward');
        break;
      }
      default: {
        break;
      }
    }
  }

  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
    this.replayImgSrc = this.envService.getReplayImgSrc();
    this.tripDetails = this.commonService.response['tripDetails'];
    this.locationListResSubsription =
      this.commonService.locationListRes.subscribe((res) => {
        this.locationList = res;
      });
    console.log("tripDetailsShuttle", this.tripDetails);

    if (!this.tripDetails.shuttleStops) {
      this.isShuttle = false;
    }
    else {
      this.isShuttle = true;
    }
    this.commonService.employeeDetails$.subscribe((res)=>{
      this.employeeDetails=res;
    })
    this.cabSignInLocations = this.tripDetails.employees.filter((employee:any) =>{
      return !employee.noShow && employee.actualPickupTime
    })

    this.cabSignOutLocations = this.tripDetails.employees.filter((employee:any) =>{
      return !employee.noShow && employee.actualDropTime
    })

     this.signInLocationGeoCordsMap = this.employeeDetails
      .filter((employee: any) => employee.actualPickupTime !== 0 && employee.actualPickupLocation.geocord !== null) // skip stops where actualPickupTime is null
      .map((employee: any) => {
        const [lat, lng] = employee.actualPickupLocation.geocord.split(",");
        return {
          position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
          name: employee?.name,
          status: employee?.employeeTrackStatus,
          gender:employee.gender,
          empId: employee?.Id,
          pickUp: employee?.signIn,
          signInLocation: employee?.actualPickupLocation?.address,
          plannedLocation: employee?.plannedPickupLocation?.address,
          empStatus: employee.empStatus,
        };
      })
      .sort((a: any, b: any) => a.signIn - b.signIn);

    if (this.isShuttle) this.shuttleStops = this.tripDetails.shuttleStops;
    else this.shuttleStops = this.tripDetails.employees;

    this.isStopVisible = new Array<boolean>(this.shuttleStops.length).fill(
      false
    );
    this.totalTripTime =
      this.tripDetails.actualEndTime - this.tripDetails.actualStartTime;
    this.shuttleStops.forEach((stop) => {
      const stopTime =
        stop.actualArrivalTime - this.shuttleStops[0].actualArrivalTime;
      this.stopsTime.push(stopTime);
    });

    this.tripCurrTime = DateUtils.formatTimeWithZone(this.tripDetails['actualStartTime'], this.commonService.timeZone, 'LT');

    this.rangerValue = this.tripDetails.actualStartTime;

    this.sosAlertRelativeTimeStamps = this.eventLogicService.getEvent('sos');
    this.callEmployee = this.driverData?.["callEmployeeDriverActions"];
    this.noShow  = this.driverData?.["noShowDriverActions"];
    this.vehicleArrivedIntervals = this.eventLogicService.getEvent('vehicle-arrived');
    this.vehicleStoppageIndexes =
      this.eventLogicService.getEvent('vehicle-stoppage');
    this.deviceOffRelativeTimeStamps =
      this.eventLogicService.getEvent('device-off');
    this.noNetworkRelativeTimeStamps =
      this.eventLogicService.getEvent('network-loss');
    this.seatBeltAlertTime=this.eventLogicService.getEvent('seat-belt')  

    this.shuttleStops.forEach((stop, index) => {
      if (stop.actualArrivalGeoCode != null && !stop.skipped) {
        const marginLeftValue =
          ((stop.actualArrivalTime - this.tripDetails.actualStartTime) /
            (this.tripDetails.actualEndTime -
              this.tripDetails.actualStartTime)) *
          100;

        this.shuttleStopRelativeTimeStamps.push({
          stopType:
            index == 0
              ? 'start'
              : index == this.shuttleStops.length - 1
                ? 'last'
                : 'middle',
          address: stop.address,
          stopNumber: index,
          marginLeft: marginLeftValue > 100 ? 99 : marginLeftValue,
        });
      }
    });

    // if login trip and no geofence hit at office (last stop)
    if (
      this.tripDetails.direction == 'IN' &&
      this.shuttleStops[this.shuttleStops.length - 1].actualArrivalGeoCode ==
      null
    ) {
      this.shuttleStopRelativeTimeStamps.push({
        stopType: 'last',
        address: this.shuttleStops[this.shuttleStops.length - 1].address,
        stopNumber: this.shuttleStops.length - 1,
        marginLeft: 99,
      });
    }

    console.log('in player');
    console.log('sos', this.sosAlertRelativeTimeStamps);
    console.log('stop', this.vehicleStoppageIndexes);
    console.log('device off', this.deviceOffRelativeTimeStamps);
    console.log('network loss', this.noNetworkRelativeTimeStamps);
    console.log('shuttle stops', this.shuttleStopRelativeTimeStamps);

    this.tripPlayerSubscription = this.mapControlService.tripPlayer$
      .pipe(skip(1))
      .subscribe((res) => {
        if (res) {
          this.handleRange(res);
        }
      });

    const timestampsInterval =
      (this.tripDetails.actualEndTime - this.tripDetails.actualStartTime) / 15;

    for (let i = 0; i < 16; i++) {
      const t = DateUtils.formatTimeWithZone(this.tripDetails.actualStartTime + i * timestampsInterval, this.commonService.timeZone, 'hh:mm');
      this.timestamps.push(t);
    }

    // Event visiblity map
    // this.events.forEach(evnt => {
    //   this.eventVisibility.set(evnt['event_icon_add'], true)
    // });
            this.commonService.fixedToEnd.subscribe((res) => {   
          if(res){
            this.isActualPause=true;
            this.handleRangeClick(null);
          }
         })
  }

  ngAfterViewInit() {
    this.tripEndCallSubscription =
      this.mapControlService.tripEndCall$.subscribe((res) => {
        if (typeof res === 'boolean') {
          this.isPaused = res;
          this.tripEnded = true;
        }
      });
    this.callForPauseSubscription = this.mapControlService.callForPause$
      .pipe(skip(1))
      .subscribe((res) => {
        this.isPaused = res;
      });
    this.getEventsRelativeTimeStamp();

    this.callForFilterChangeSubscription =
      this.mapControlService.callForFilterChange$
        .pipe(skip(1))
        .subscribe((res) => {
          if (res) {

            // Update Map
            this.eventVisibility = this.mapControlService.eventVisibility;        
            // const foundIcons = this.iconsList.filter(
            //   (icon) => icon.type === res.eventName
            // );
            // if (foundIcons) {
            //   foundIcons.forEach((icon) => {
            //     icon.visible = res.isChecked;
            //   });
            // }

            // this.eventVisibility.set(res.eventName, res.isChecked);
          }
        });
  }

  getEventsRelativeTimeStamp() {
    this.locationList.forEach((location, index) => {
      if (
        this.sosAlertRelativeTimeStamps?.some((loc) => {
          return (index>0 && loc.time>=this.locationList[index-1].time && loc.time<=this.locationList[index].time )
        })
      ) {
        this.iconsList.push({
          time: location.time,
          type: 'sos',
          marker: `${this.replayImgSrc}assets/icons/sos.svg`,
          visible: false,
          marginLeft:
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });
      }
      if (
        this.seatBeltAlertTime.some((loc) =>
          {
            return (index>0 && loc.startTime>=this.locationList[index-1].time && loc.startTime<=this.locationList[index].time )
          }
        )
      ) {
        let seatBeltData=this.seatBeltAlertTime.find((loc) => loc.startTime>=this.locationList[index-1].time && loc.startTime<=this.locationList[index].time);
        let outOfRange = false;
        let marginLeft = (seatBeltData.startTime - this.tripDetails.actualStartTime) /
                         (this.tripDetails.actualEndTime - this.tripDetails.actualStartTime) * 100

        if(marginLeft > 100){
        marginLeft = 97 + Math.random();
        outOfRange= true;
        }
        this.iconsList.push({
          time: seatBeltData.startTime,
          type: 'seat-belt-worn',
          marker:seatBeltData?.seatBeltStatus? `${this.replayImgSrc}assets/icons/seat-belt-worn.svg`:`${this.replayImgSrc}assets/icons/seat-belt-not-worn.svg`,
          visible: false,
          marginLeft,
          outOfRange
        });
      }

      if (
        this.deviceOffRelativeTimeStamps?.some(
          (interval) => interval[2] == location.time
        )
      ) {
        const currInterval = this.deviceOffRelativeTimeStamps.find(
          (interval) => interval[2] == location.time
        );
        this.iconsList.push({
          time: location.time,
          type: 'device-off',
          marker: `${this.replayImgSrc}assets/icons/device-off.svg`,
          visible: false,
          marginLeft:
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });

        // insert end marker
        this.iconsList.push({
          time: location.time + currInterval[1] - currInterval[0],
          type: 'device-off',
          marker: `${this.replayImgSrc}assets/icons/device-off.svg`,
          visible: false,
          marginLeft:
            ((location.time -
              this.tripDetails.actualStartTime +
              currInterval[1] -
              currInterval[0]) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });
      }

      // startTime

      if (
        this.vehicleStoppageIndexes?.some((stop:any) => {
          return (index>0 && stop.startTime>=this.locationList[index-1].time && stop.startTime<=this.locationList[index].time )
        })
      
      ) {
        this.iconsList.push({
          time: location.time,
          type: 'vehicle-stoppage',
          marker: `${this.replayImgSrc}assets/icons/vehicle-stoppage.svg`,
          visible: false,
          marginLeft:
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });
      }

      if (
        this.noNetworkRelativeTimeStamps?.some(
          (interval) => interval[0] == location.time
        )
      ) {
        this.iconsList.push({
          time: location.time,
          type: 'no-network-start',
          marker: `${this.replayImgSrc}assets/icons/no-network-start.svg`,
          visible: false,
          marginLeft:
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });
      }

      if (
        this.noNetworkRelativeTimeStamps?.some(
          (interval) => interval[1] == location.time
        )
      ) {
        this.iconsList.push({
          time: location.time,
          type: 'no-network-start',
          marker: `${this.replayImgSrc}assets/icons/no-network-end.svg`,
          visible: false,
          marginLeft:
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });
      }
      if(
        this.callEmployee?.some((loc)=> {
            return (index>0 && loc.callStartTime>=this.locationList[index-1].time && loc.callStartTime<=this.locationList[index].time )
        }
        )
      ){
        this.iconsList.push({
          time: location.time,
          type: 'call-emp-events',
          marker: `${this.replayImgSrc}assets/icons/call-employee-marker-on-map.svg`,
          visible: false,
          marginLeft: location.time < this.tripDetails.actualStartTime ? Math.random() :
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });       
      }
      if(
        this.noShow?.some((loc)=> {
            return (index>0 && loc.markedAt>=this.locationList[index-1].time && loc.markedAt<=this.locationList[index].time )
        }
        )
      ){
        this.iconsList.push({
          time: location.time,
          type: 'no-show-events',
          marker: `${this.replayImgSrc}assets/icons/no-show-events.svg`,
          visible: false,
          marginLeft:location.time < this.tripDetails.actualStartTime ? Math.random() :
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });       
      }


      //Vehicle arrived events
      if(
        this.vehicleArrivedIntervals?.some((loc)=> {
            return (index>0 && loc.startTime>=this.locationList[index-1].time && loc.startTime<=this.locationList[index].time )
        }
        )
      ){
        this.iconsList.push({
          time: location.time,
          type: 'vehicle-arrived',
          marker: `${this.replayImgSrc}assets/icons/vehicle-arrived-marker-on-map.svg`,
          visible: false,
          marginLeft:location.time < this.tripDetails.actualStartTime ? Math.random() :
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });       
      }

      if(
        this.cabSignOutLocations.some((loc) => 
          {
          return ( index>0 && (loc.actualDropTime>=this.locationList[index-1].time && loc.actualDropTime<=this.locationList[index].time) || (loc.actualDropTime == this.locationList[index].time) )
     } )
      ){
        
        let outOfRange = false;
        let marginLeft = (location.time - this.tripDetails.actualStartTime) /
                         (this.tripDetails.actualEndTime - this.tripDetails.actualStartTime) * 100

        if(marginLeft > 100){
        marginLeft = 97 + Math.random();
        outOfRange= true;
        }
        this.iconsList.push({
          time: location.time,
          type: 'signout-employee',
          marker: `${this.replayImgSrc}assets/icons/signout-employee.svg`,
          visible: false,
          marginLeft,
          outOfRange
            
        });       
      }
      if(
        this.cabSignInLocations.some((loc) => 
          {
          return ( index>0 && (loc.actualPickupTime>=this.locationList[index-1].time && loc.actualPickupTime<=this.locationList[index].time) || (loc.actualPickupTime == this.locationList[index].time) )
     } )
      ){
        let outOfRange = false;
        let marginLeft = (location.time - this.tripDetails.actualStartTime) /
                         (this.tripDetails.actualEndTime - this.tripDetails.actualStartTime) * 100

        if(marginLeft > 100){
        marginLeft = 97.5 + Math.random();
        outOfRange= true;
        }
        this.iconsList.push({
          time: location.time,
          type: 'signin-employee',
          marker: `${this.replayImgSrc}assets/icons/signin-employee.svg`,
          visible: false,
          marginLeft,
          outOfRange
        });       
      }
      if(
        this.signInLocationGeoCordsMap.some((loc)=> {

            return (index>0 && this.convertPickUpToEpoch(loc.pickUp,this.locationList[index].time)>=this.locationList[index-1].time && this.convertPickUpToEpoch(loc.pickUp,this.locationList[index].time)<this.locationList[index].time  )
        }
        )
      ){
        this.iconsList.push({
          time: location.time,
          type: 'signin-employee',
          marker: `${this.replayImgSrc}assets/icons/signin-employee.svg`,
          visible: false,
          marginLeft:
            ((location.time - this.tripDetails.actualStartTime) /
              (this.tripDetails.actualEndTime -
                this.tripDetails.actualStartTime)) *
            100,
        });       
      }
    });

    console.log("iconlist", this.iconsList);
  }


  convertPickUpToEpoch(pickUp, epochTime) {
    const locationDate = new Date(epochTime);
    const [hours, minutes] = pickUp.split(':').map(Number);
    const pickUpDate = new Date(locationDate.getFullYear(), locationDate.getMonth(), locationDate.getDate(), hours, minutes);
    return pickUpDate.getTime();
  }
  setPlaybackSpeed(speed: number) {
    this.activePlaybackSpeed = '' + speed;
    this.mapControlService.playbackSpeed = speed;
    this.mapControlService.isSpeedChanged = true;
    this.playbackSpeed = this.mapControlService.playbackSpeed;
    this.toggleDropdown();
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  handleMouseDown() {
    this.isActualPause = this.isPaused;
    this.mapControlService.pauseTrip();
  }
  handleStopMousedown() {    
    this.isActualPause = this.isPaused;
  }

  handleRangeClick(value) {
    if (!value) {
      value = this.tripDetails.actualEndTime;
    }
    this.mapControlService.setMapAtTime(Number(value));
    this.handleRange(value);
    if (!this.isActualPause) {
      this.mapControlService.startTrip();
      this.isActualPause = this.isPaused;
    }
    else{
      this.mapControlService.pauseTrip();

    }
  }

  handleControl(action: String) {
    switch (action) {
      case 'backward': {
        this.handleMouseDown();
        let newTime = this.rangerValue - 5 * 60 * 1000;
        if (newTime < this.tripDetails.actualStartTime) {
          newTime = this.tripDetails.actualStartTime;
        }
        this.handleRangeClick(newTime);
        break;
      }
      case 'pause': {
        this.mapControlService.pauseTrip();
        break;
      }
      case 'play': {
        console.log('tripended', this.tripEnded);
        this.mapControlService.startTrip();
        this.isPaused = this.mapControlService.isPaused;
        break;
      }
      case 'forward': {
        this.handleMouseDown();
        let newTime = this.rangerValue + 5 * 60 * 1000;
        if (newTime > this.tripDetails.actualEndTime) {
          newTime = this.tripDetails.actualEndTime;
        }
        this.handleRangeClick(newTime);
        break;
      }
      case 'replay': {
        this.handleRangeClick(this.tripDetails.actualStartTime);
        break;
      }
      default: {
        console.log('default');
      }
    }
  }

  handleRange(value) {
    this.rangerValue = value;

    // this.iconsList.forEach((icon) => {
    //   console.log(icon.type,this.eventVisibility.get(icon.type))
    //   if (value >= icon.time && this.eventVisibility.get(icon.type)) {
    //     icon.visible = true;
    //   } else {
    //     icon.visible = false;
    //   }
    // });

    this.progress =
      ((value - this.tripDetails.actualStartTime) /
        (this.tripDetails.actualEndTime - this.tripDetails.actualStartTime)) *
      100;
      const rangerEle = document.querySelector('#ranger') as HTMLElement;
     if (rangerEle) {
      rangerEle.style.background =
      'linear-gradient(to right, #638FE7 ' +
      this.progress +
      '%, #d9d9d9 ' +
      this.progress +
      '%)';
     }
    this.tripCurrTime = DateUtils.formatTimeWithZone(Number(value), this.commonService.timeZone, 'LT');
  }

  handleZoom(value) {
    if (value == 500) {
      this.timestamps = [];
      const timestampsInterval = Math.floor(
        (this.tripDetails.actualEndTime - this.tripDetails.actualStartTime) / 30
      );
      for (let i = 0; i < 31; i++) {
        const t = DateUtils.formatTime(this.tripDetails.actualStartTime + i * timestampsInterval, 'hh:mm');
        this.timestamps.push(t);
      }
    } else {
      this.timestamps = [];
      const timestampsInterval = Math.floor(
        (this.tripDetails.actualEndTime - this.tripDetails.actualStartTime) / 15
      );
      for (let i = 0; i < 16; i++) {
        const t = DateUtils.formatTime(this.tripDetails.actualStartTime + i * timestampsInterval, 'hh:mm');
        this.timestamps.push(t);
      }
    }
    this.zoom = value;
    this.zoomProgress = ((value - 50) / 500) * 100;
    document.querySelector('#zoomer')['style']['background'] =
      'linear-gradient(to right, #638fe7 ' +
      this.zoomProgress +
      '%, #cbddfb ' +
      this.zoomProgress +
      '%)';
  }

  toggleShowStop(stopIndex: number) {
    this.isStopVisible[stopIndex] = !this.isStopVisible[stopIndex];
  }

  toggleShowOffice() {
    this.showOffice = !this.showOffice;
  }

  ngOnDestroy() {
    console.log('player destroy', this.rangerValue);
    this.handleMouseDown();
    this.handleRange(this.tripDetails.actualStartTime);
    this.tripPlayerSubscription && this.tripPlayerSubscription.unsubscribe();
    this.tripEndCallSubscription && this.tripEndCallSubscription.unsubscribe();
    this.callForPauseSubscription &&
      this.callForPauseSubscription.unsubscribe();
    this.callForFilterChangeSubscription &&
      this.callForFilterChangeSubscription.unsubscribe();
    this.locationListResSubsription &&
      this.locationListResSubsription.unsubscribe();
      this.mapControlService.clearMap();
      this.mapControlService.restartCall$.next('');
  }
}
